import { z } from 'zod';

import type { Candidate } from './candidate';
import { CandidateSchema } from './candidate';
import { GroupedExperiencesSchema } from './grouped-experiences';
import { CandidateLegalTechSkillSchema } from './candidate-legal-tech-skill';
import { HomeOfficeSchema } from './home-office';

export const CandidateBioSchema = CandidateSchema.pick({
  id: true,
  calculatedDisplayName: true,
  calculatedFirstName: true,
  pronouns: true,
  addressCity: true,
  addressState: true,
  addressCountry: true,
  yearsOfExperience: true,
  profileStatus: true,
  isProfileShared: true,
  profileImageKey: true,
  badges: true,
  businessTitle: true,
  primaryPracticeArea: true,
  primaryFocusArea: true,
  degrees: true,
  lawDegreeSchools: true,
  lawFirms: true,
  industries: true,
  certifications: true,
  barredLocations: true,
  languages: true,
}).extend({
  homeOffice: HomeOfficeSchema.pick({ name: true }).nullable(),
  groupedExperiences: z.array(GroupedExperiencesSchema),
  legalTechSkills: z.array(CandidateLegalTechSkillSchema),
});

export type CandidateBio = z.infer<typeof CandidateBioSchema>;

export type BioRenderableCandidate = Pick<
  CandidateBio,
  | 'id'
  | 'calculatedDisplayName'
  | 'calculatedFirstName'
  | 'pronouns'
  | 'addressCity'
  | 'addressState'
  | 'addressCountry'
  | 'yearsOfExperience'
  | 'profileStatus'
  | 'isProfileShared'
  | 'profileImageKey'
  | 'badges'
  | 'businessTitle'
  | 'primaryPracticeArea'
  | 'primaryFocusArea'
  | 'degrees'
  | 'lawDegreeSchools'
  | 'lawFirms'
  | 'industries'
  | 'certifications'
  | 'barredLocations'
  | 'languages'
> &
  Partial<
    Pick<CandidateBio, 'homeOffice'> &
      Pick<Candidate, 'showReputation' | 'candidateReputation'>
  >;
